import defiantModule from 'defiant.js/dist/defiant.js';

const tgg = typeof window !== 'undefined' ? window.tgg : undefined;
// There is an issue with the NodeJS bundled version, which causes runtime issues
// in the browser.
const defiant = (typeof window !== 'undefined' ? window.defiant : undefined) || defiantModule; 

const snapshotsReadyPromise = new Promise((resolve) => {
    let guidelinesSnapshot;
    let topicSnapshot;
    let snapshotsCompleted = 0;

    console.time("Created Enhanced Snapshots");

    const checkSnapshotsReady = () => {
        snapshotsCompleted++;
        if (snapshotsCompleted === 2) {
            console.timeEnd("Created Enhanced Snapshots");
            resolve({ guidelinesSnapshot, topicSnapshot });
        }
    };

    defiant.getSnapshot(tgg?.guidelines, (gsnapshot) => {
        guidelinesSnapshot = gsnapshot;
        checkSnapshotsReady();
    });

    defiant.getSnapshot(tgg?.topics, (tsnapshot) => {
        topicSnapshot = tsnapshot;
        checkSnapshotsReady();
    });
});

const getSnapshots = () => snapshotsReadyPromise;
export default getSnapshots
